export default "__VITE_ASSET__87b2faf6__"